module.exports = __webpack_public_path__ + "static/media/jon.c3fbd5ca.jpg";